import { _ } from "ynf-core-middleware";
import { TableStore } from "../TableStore";
import { ColumnsType } from "../types";
import { BaseRowStore } from "../row/BaseRowStore";
import { BaseColumn } from "./BaseColumn";
import { precisionMetrics, precisionType } from '@utils/Utils';
import { observable, makeObservable } from 'mobx';
/**
 * 1. 接入组件精度控制属性
 * 2. 接入舍入策略：round floor ceil
 * 3. 接入自定义策略
 */

interface precisionType {
  ROUND: 'round',
  FLOOR:'floor',
  CEIL: 'ceil'
}

interface NumberColumnsType extends ColumnsType {
  precision?: number,
  precisionMethod?: Function | precisionType,
  usePrecisionInStore?: Boolean
}

export class NumberColumn extends BaseColumn {
  precision?: number
  precisionMethod?: Function | precisionType
  constructor(column: NumberColumnsType, tableStore: TableStore) {
    super(column, tableStore);
    this.precision = column?.usePrecisionInStore ? column.precision : undefined
    this.precisionMethod = column.precisionMethod
    makeObservable(this, {
      precision: observable,
      setPrecisionMethod: observable
    })
  }

  getValue(row: BaseRowStore<any>) {
    return this.processData(row)
  }

  getEntityValue(storeAlias: string, row: BaseRowStore<any>) {
    return this.processData(row, storeAlias)
  }

  get value() {
    return (row: BaseRowStore<any>) => {
      return this.processData(row)
    }
  }

  private processData(row: BaseRowStore<any>, key?: string) {
    const fieldKey = key ? key : this.getField()
    const value = row?.getTrueValue(fieldKey);
    return precisionMetrics(value, this.precision, this.precisionMethod)
  }

  setPrecision(value: number) {
    this.precision = value
  }

  setPrecisionMethod(method?: precisionType | Function) {
    this.precisionMethod = method
  }
}
